import React,{ Fragment, useState, useEffect } from 'react'
import { Box } from '@chakra-ui/react';
import AllNotification from '../../component/AllNotification';
import { Auth } from '../../component/Auth';
// import { AiOutlineConsoleSql } from 'react-icons/ai';




const NotificationAll = () => {
  const [notificationData, setNotificationData] = useState([])
  const [statusToggle, setStatusToggle] = useState(null)
  const [ticketType, setTicketType] = useState("")
  const [notificationTitle, setNotificationTitle] = useState("All Notifications")
  const [isLoading, setIsLoading] = useState({loading: true, error: false})

  useEffect(() => {
   
    const fetchData = async () => {
      try{
      let response = await fetch(`${process.env.REACT_APP_NOTIFICATION_BASE_URL}/get-notifications`, {
        method: "GET",
        headers: {
          'Authorization': Auth()
        }
      });
      let data = await response.json();
      setIsLoading({loading: false, error: false})
      setNotificationData(data)
      }catch(err) {
        console.log(err)
        setIsLoading({loading: false, error: true})
      }
    }
    fetchData()
},[statusToggle,ticketType])

const statusUpdate = (id) => {
  setStatusToggle(id)
}

const filterId = (id, title) => {
  setTicketType(id)
  setNotificationTitle(title)

  if(id === 'ALL'){
    setTicketType("")  
  }
}

  return (
    <Fragment>
      <Box p={5} flex="1" pb={0} w={'100%'}>
    <AllNotification
      title={'All Notifications'}
      title2={notificationTitle.includes('All') ? notificationTitle : ('All ' + notificationTitle + " Notifications")}
      head={["Notification Name", "Recipient", "Manage Notifications", ""]}
      data={ticketType.length > 0 ? notificationData.filter((d) => d.ticketType === ticketType) : notificationData}
      statusToggle={statusUpdate}
      filterId={filterId}
      isLoading={isLoading}
      />
     </Box>
    </Fragment>
  )
}

export default NotificationAll